import { render, staticRenderFns } from "./ItemWork.vue?vue&type=template&id=8fb0ad5c&"
import script from "./ItemWork.vue?vue&type=script&lang=js&"
export * from "./ItemWork.vue?vue&type=script&lang=js&"
import style0 from "./ItemWork.vue?vue&type=style&index=0&id=8fb0ad5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports